const JobBoxSkeleton = (props) => {
    const { className = '' } = props;   
    return (
        <div className={`border border-lightGray rounded-2xl overflow-hidden ${className}`}>
            <div className='h-40 w-full bg-gray animate-pulse'></div>
            <div className='p-4 pt-0 cursor-pointer'>
                <div className='flex items-end justify-between'>
                    <div className='min-w-14 w-14 h-14 rounded-full overflow-hidden border border-lightGray bg-gray animate-pulse -mt-6'></div>
                    <span className='font-medium text-sm w-20 h-5 bg-gray animate-pulse'></span>
                </div>
                <div className='flex flex-col gap-0.5 mt-4'>
                    <h4 className='text-lg font-bold w-20 h-7 rounded bg-gray animate-pulse'></h4>
                    <span className='font-medium  w-24 h-7 rounded bg-gray animate-pulse'></span>
                    <div className='flex items-center gap-1.5 text-sm'>
                        <span className='text-sm w-10 h-5 rounded bg-gray animate-pulse'></span>
                        <span className="rounded-full overflow-hidden text-gray">•</span>
                        <span className='w-14 h-5 rounded bg-gray animate-pulse'></span>
                        <span className="rounded-full overflow-hidden text-gray">•</span>
                        <span className='w-14 h-5 rounded bg-gray animate-pulse'></span>
                    </div>
                    <div className='flex items-center justify-between md:gap-5 gap-3 mt-5'>
                        <div className='flex flex-col gap-0.5'>
                            <span className='font-semibold w-12 h-6 rounded bg-gray animate-pulse'></span>
                            <span className='text-sm w-10 h-5 rounded bg-gray animate-pulse'></span>
                        </div>
                        <div className='flex flex-col gap-0.5'>
                            <span className='font-semibold w-12 h-6 rounded bg-gray animate-pulse'></span>
                            <span className='text-sm w-10 h-5 rounded bg-gray animate-pulse'></span>
                        </div>
                    </div>
                    <div className='flex items-center justify-between md:gap-5 gap-3 mt-5'>
                        <div className='flex gap-5 justify-start'>
                            <div className='text-sm w-5 h-5 rounded bg-gray animate-pulse'></div>
                            <div className='text-sm w-5 h-5 rounded bg-gray animate-pulse'></div>
                            <div className='text-sm w-5 h-5 rounded bg-gray animate-pulse'></div>
                            <div className='text-sm w-5 h-5 rounded bg-gray animate-pulse'></div>
                        </div>
                        <div className='text-sm w-5 h-5 rounded bg-gray animate-pulse'></div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default JobBoxSkeleton
